import { createMatchSelector } from 'connected-react-router';
import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { Selectors as RouterSelectors } from 'router';
import { Types as CampaignEditorActionTypes } from 'sections/campaigns/state/editor';
import { Selectors as RulesetSplitTestSelectors } from 'sections/campaigns/state/rulesetSplitTests';
import { Types } from 'services/genericAPIGatewayService';
import { Action } from 'store';

export const readOnlyCampaignMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (
  action: Action,
): any => {
  const state = store.getState();
  const isEditor = createMatchSelector('/sites/:siteId/campaigns/campaigns/:campaignId');
  const isControlCenter = createMatchSelector('/sites/:siteId/campaigns/campaigns/:campaignId/control_center/:tab');
  const matchEditor = isEditor(state);
  const matchControlCenter = isControlCenter(state);
  if (!!matchEditor || !!matchControlCenter) {
    const campaignId = RouterSelectors.getCampaignId(state);
    const isInSplitTest = RulesetSplitTestSelectors.getActiveSplitTestsForCampaign(state, campaignId).length > 0;
    if (
      isInSplitTest &&
      (action.type === Types.UPDATE_LOCAL ||
        action.type === Types.CREATE_LOCAL_WITH_TEMPORARY_ID ||
        action.type === CampaignEditorActionTypes.DELETE_RULESET)
    ) {
      return; // Swallow the action as the campaign is in read only mode
    }
  }
  return next(action);
};
